import group from "../images/bot-icon.png";
import {Constants} from "../Constants";


const BotHero = ({isLoading}) => {
    return (<div className="bot-icon">
            <img src={group} alt="Bot Icon"/>
        {!isLoading && <p className="instruction-text">
                Welcome to {Constants.API_NAME}, What can I do for you</p>}
        </div>)
}

export default BotHero
